import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

// set REACT_APP_DATADOG_CLIENT_TOKEN and REACT_APP_DATADOG_RUM_APP_ID in .env to test datadog
// manually error function example:
// datadogLogs.logger.error('test', { name: 'buttonName', id: 123 })
const initDataDog = async () => {
  if (!process.env.DATADOG_CLIENT_TOKEN || !process.env.DATADOG_RUM_APP_ID) {
    console.log(
      "Datadog client token or app ID has not been set. Logs are not being sent to Datadog",
    );
    return;
  }

  const env = process.env.DD_ENV ? process.env.DD_ENV : "development";

  datadogLogs.setLoggerGlobalContext({ app: "dojo" });

  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: "dojo-web",
    env,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error"], // only send console errors
    sampleRate: 100,
  });

  datadogRum.init({
    applicationId: process.env.DATADOG_RUM_APP_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: "datadoghq.com",
    service: "dojo-web",
    env,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version,
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });

  datadogRum.startSessionReplayRecording();
};

export default initDataDog;
